module.exports = __webpack_public_path__ + "img/knsu_gallery11.449a7d3d.jpg";